export default __webpack_public_path__ + "static/petrine-logo-5d742529c184324289f0a7915b9cddd9.png";